var _defs, _path, _circle, _g, _g2, _path2, _g3, _circle2, _circle3, _g4, _g5, _text, _path3, _path4, _g6, _g7, _g8, _g9, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g0, _g1, _g10, _g11, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Successful_Purchase_illustration",
    width: 180.255,
    height: 102.427,
    viewBox: "0 0 180.255 102.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-12{fill:#e9edf1}.cls-2{fill:#bac0cd}.cls-16,.cls-17{fill:none}.cls-13,.cls-5{fill:#fff}.cls-6{fill:#cdd2dc}.cls-7{fill:#753bbd}.cls-8{fill:#8a5aea}.cls-12{opacity:.209}.cls-13{opacity:.74}.cls-16{stroke:#bac0cd}.cls-18{stroke:none}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20212",
    d: "M-14269.812 9918.455s-21.312-43.185 20.544-79.968 44.552-15.641 39.523-10.319-20.652 27.106-14.843 41.982 28.36 35.554 60.614 3.974 39.97-39.817 59.579-15.563 2.488 61.161 2.488 61.161l-168.945-1.267",
    className: "cls-1",
    transform: "translate(14275.237 -9817.295)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2437",
    cx: 14,
    cy: 14,
    r: 14,
    className: "cls-2",
    transform: "translate(33.001 73.427)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2438",
    fill: "none",
    stroke: "#f4f4f4",
    transform: "translate(36.001 76.427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    className: "cls-17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5102",
    transform: "rotate(-25.97 -27962.418 -25961.446)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4240",
    width: 47,
    height: 30,
    className: "cls-2",
    rx: 2,
    transform: "translate(-14134 9716.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4241",
    fill: "#fff",
    d: "M0 0H47V5H0z",
    opacity: 0.7,
    transform: "translate(-14134 9723.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4242",
    d: "M0 0H19V2H0z",
    className: "cls-5",
    transform: "translate(-14131 9730.539)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4239",
    d: "M0 0H180V1H0z",
    className: "cls-6",
    transform: "translate(.001 101.427)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5101",
    transform: "translate(14267.001 -9655.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4206",
    d: "M2 0h2v71H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    className: "cls-7",
    transform: "translate(-14201 9686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4204",
    width: 42,
    height: 75,
    className: "cls-8",
    rx: 2,
    transform: "translate(-14197 9682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4207",
    d: "M0 0h1a2 2 0 0 1 2 2v67a2 2 0 0 1-2 2H0V0z",
    className: "cls-7",
    transform: "translate(-14155 9686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4205",
    d: "M0 0H32V31H0z",
    className: "cls-5",
    transform: "translate(-14192 9697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4211",
    fill: "#f5f8fb",
    d: "M0 0H26V26H0z",
    transform: "translate(-14189 9665)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4212",
    width: 32,
    height: 2,
    fill: "#474e5d",
    rx: 1,
    transform: "translate(-14192 9691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4217",
    d: "M0 0H32V3H0z",
    className: "cls-1",
    transform: "translate(-14192 9725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4219",
    d: "M0 0H3V31H0z",
    className: "cls-1",
    transform: "translate(-14192 9697)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5101-2",
    transform: "translate(-14186.488 9667.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4222",
    d: "M0 0H3V7H0z",
    className: "cls-6",
    transform: "translate(.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4223",
    d: "M0 0H1V7H0z",
    className: "cls-6",
    transform: "translate(4.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4224",
    d: "M0 0H1V7H0z",
    className: "cls-6",
    transform: "translate(6.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4225",
    d: "M0 0H3V7H0z",
    className: "cls-6",
    transform: "translate(8.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4226",
    d: "M0 0H1V7H0z",
    className: "cls-6",
    transform: "translate(12.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4227",
    d: "M0 0H1V7H0z",
    className: "cls-6",
    transform: "translate(14.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4228",
    d: "M0 0H4V7H0z",
    className: "cls-6",
    transform: "translate(16.488 .383)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4237",
    width: 20,
    height: 1,
    className: "cls-6",
    rx: 0.5,
    transform: "translate(-14186 9678)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4238",
    width: 20,
    height: 1,
    className: "cls-6",
    rx: 0.5,
    transform: "translate(-14186 9681)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2435",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-5",
    transform: "translate(106.001 94.427)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2436",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-5",
    transform: "translate(110.001 94.427)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5104",
    transform: "translate(14129.001 -9654.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20213",
    d: "M0 0h24v4H0z",
    className: "cls-6",
    transform: "translate(-14075 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4264",
    fill: "#fff",
    d: "M0 0H4V4H0z",
    opacity: 0.736,
    transform: "translate(-14056 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4265",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14058 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4266",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14060 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4267",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14062 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4268",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14064 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4269",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14066 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4270",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14068 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4271",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14070 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4272",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14072 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4273",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14074 9748)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5105",
    transform: "translate(14128.001 -9650.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4263",
    d: "M0 0H24V4H0z",
    className: "cls-2",
    transform: "translate(-14075 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4264-2",
    d: "M0 0H4V4H0z",
    className: "cls-13",
    transform: "translate(-14056 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4265-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14058 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4266-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14060 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4267-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14062 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4268-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14064 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4269-2",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14066 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4270-2",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14068 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4271-2",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14070 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4272-2",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14072 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4273-2",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(-14074 9748)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "P",
    fill: "#fff",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "16px",
    fontWeight: 700,
    transform: "translate(47.001 93.427)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.16,
    y: 0
  }, "P"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4274",
    d: "M0 0H14V1H0z",
    className: "cls-5",
    transform: "translate(40.001 84.427)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4275",
    d: "M0 0H14V1H0z",
    className: "cls-5",
    transform: "translate(40.001 86.427)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5106",
    transform: "translate(13999.351 -9703.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20215",
    d: "M16.509 8.322l-5.989 6-2.593-2.6a1.132 1.132 0 0 0-1.6 1.6l3.4 3.4a1.132 1.132 0 0 0 1.6 0l6.793-6.793a1.132 1.132 0 0 0-1.6-1.6z",
    className: "cls-8",
    transform: "translate(-13920.41 9746.429)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5107",
    transform: "translate(14129.001 -9657.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4282",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4283",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4284",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4285",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4286",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4287",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4288",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4289",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4290",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9746)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5108",
    transform: "translate(14130.001 -9654.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4291",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14042 9728)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4292",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14035 9728)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14049 9728)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5103",
    transform: "translate(14237.001 -9645.112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4240-2",
    width: 49,
    height: 30,
    className: "cls-6",
    rx: 2,
    transform: "translate(-14134 9716.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4241-2",
    fill: "#fff",
    d: "M0 0H49V5H0z",
    opacity: 0.699,
    transform: "translate(-14134 9723.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4242-2",
    d: "M0 0H19V2H0z",
    className: "cls-5",
    transform: "translate(-14131 9730.539)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4251",
    d: "M0 0H24V4H0z",
    className: "cls-6",
    transform: "translate(53.001 89.427)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20216",
    d: "M0 0h4v4H0z",
    className: "cls-13",
    transform: "translate(72.001 89.427)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4253",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(70.001 89.427)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4254",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(68.001 89.427)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4255",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(66.001 89.427)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4256",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(64.001 89.427)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4257",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(62.001 89.427)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4258",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(60.001 89.427)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4259",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(58.001 89.427)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4260",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(56.001 89.427)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4261",
    d: "M0 0H1V4H0z",
    className: "cls-12",
    transform: "translate(54.001 89.427)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2439",
    className: "cls-16",
    transform: "translate(37.001 28.427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-17"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2440",
    className: "cls-16",
    transform: "translate(57.001 50.427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-17"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2441",
    className: "cls-16",
    transform: "translate(137.001 28.427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-17"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2442",
    className: "cls-16",
    transform: "translate(162.001 50.427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-17"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2443",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-17",
    transform: "translate(40.001 48.427)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2444",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-2",
    transform: "translate(45.001 64.427)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2445",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-2",
    transform: "translate(29.001 50.427)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2446",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-2",
    transform: "translate(121.001 43.427)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2447",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-2",
    transform: "translate(158.001 38.427)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTransaction);
export default __webpack_public_path__ + "static/media/success-transaction.ac7a4887945021e5cbd1e0386c76a662.svg";
export { ForwardRef as ReactComponent };